import React from "react";
import optimizedLogo from "../assets/silver-drive-logo.webp";

export const LOGO_URL = optimizedLogo;
export const OPAQUE_LOGO_URL = optimizedLogo;

export const LogoMark = ({ size = 48, className = "", src = LOGO_URL }) => (
  <img
    src={src}
    alt="Silver Drive Rent a Car — Dubai"
    width={Math.round((size * 1455) / 1171)}
    height={size}
    decoding="async"
    style={{ height: size }}
    className={`w-auto object-contain ${className}`}
  />
);

export default function Logo() {
  return <LogoMark size={60} />;
}
